module.exports = __webpack_public_path__ + "img/lobby.eaaa40dd.jpg";